import { createAction } from '@reduxjs/toolkit';
import { ENTRY_RULES_CLICKED } from './constants';

export const entryRulesClickedAction = createAction(ENTRY_RULES_CLICKED);
